export default "__VITE_ASSET__XPPEcktS__"